'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postUnreadConversationCountChangedEvent = undefined;

var _postExternalApiEvent = require('../../external-api-events/actions/postExternalApiEvent');

var _externalApiEventTypes = require('../../external-api-events/constants/externalApiEventTypes');

var postUnreadConversationCountChangedEvent = exports.postUnreadConversationCountChangedEvent = function postUnreadConversationCountChangedEvent(_ref) {
  var unreadCount = _ref.unreadCount;
  return function (dispatch) {
    dispatch((0, _postExternalApiEvent.postExternalApiEvent)({
      eventType: _externalApiEventTypes.UNREAD_CONVERSATION_COUNT_CHANGED,
      payload: {
        unreadCount: unreadCount
      }
    }));
  };
};